import { render, staticRenderFns } from "./InfoWizard.vue?vue&type=template&id=02b1821b&"
import script from "./InfoWizard.vue?vue&type=script&lang=js&"
export * from "./InfoWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports